import React from 'react';
import { useNavigate } from 'react-router-dom';

const CanceledPage = () => {
  const navigate = useNavigate();

  const handleTryAgain = () => {
    navigate('/');
  };

  return (
    <div className="flex font-display items-center justify-center h-screen bg-gray-50">
      <div className="bg-white p-6 rounded-lg shadow-2xl text-center relative">
        <div className="transform flex items-center justify-center w-10 h-10 bg-red-500 mx-auto text-white font-bold rounded-full">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            className="w-6 h-6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </div>
        <div className="mt-4 text-lg font-bold">Payment Unsuccessful</div>
        <div className="text-gray-600 mt-2">
          Your payment could not be processed
        </div>
        
        <button 
          onClick={handleTryAgain}
          className="mt-6 border border-black hover:bg-gray-100 px-4 py-2 rounded-lg text-sm font-medium transition-colors"
        >
          Try Again
        </button>
      </div>
    </div>
  );
};

export default CanceledPage;